import React, { useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import api from '../services/api';

export const licenseOptionLabels = { publisher: 'Fabricante', license_type: 'Tipo de licença', software_name: 'Software', plan: 'Plano' };

export default function LicenseOptionsDialog({ open, onClose, onChanged }) {
  const [options, setOptions] = useState({});
  const [kind, setKind] = useState('publisher');
  const [drafts, setDrafts] = useState({});
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [canManage, setCanManage] = useState(false);
  const load = async () => {
    const response = await api.get('/license-options');
    setOptions(response.data.options); setCanManage(response.data.can_manage);
    setDrafts(Object.fromEntries(Object.values(response.data.options).flat().map(row => [row.id, row.name])));
  };
  useEffect(() => {
    if (open) { setError(''); setName(''); setBusy(true); load().catch(err => setError(err.message)).finally(() => setBusy(false)); }
  }, [open]);
  const save = async (row = null) => {
    setBusy(true); setError('');
    try {
      const body = { kind, name: row ? drafts[row.id] : name };
      if (row) await api.put(`/license-options/${row.id}`, body);
      else await api.post('/license-options', body);
      await load(); setName(''); await onChanged?.(kind, row?.name, body.name.trim());
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };
  return <Dialog open={open} onClose={() => { if (!busy) onClose(); }} fullWidth maxWidth="sm" aria-labelledby="license-options-title">
    <DialogTitle id="license-options-title">Opções de licenças</DialogTitle>
    <DialogContent>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Alert severity="info" sx={{ mb: 2 }}>Ao renomear uma opção, as licenças que usam esse valor também serão atualizadas.</Alert>
      <TextField fullWidth select label="Campo" value={kind} disabled={busy} onChange={e => { setKind(e.target.value); setName(''); }}>
        {Object.entries(licenseOptionLabels).map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
      </TextField>
      <TableContainer sx={{ mt: 2 }}><Table size="small"><TableHead><TableRow><TableCell>Opção</TableCell><TableCell>Ação</TableCell></TableRow></TableHead><TableBody>
        {(options[kind] || []).map(row => <TableRow key={row.id}><TableCell><TextField fullWidth size="small" label={`Nome da opção ${row.name}`} value={drafts[row.id] ?? row.name} disabled={busy || !canManage} onChange={e => setDrafts(prev => ({ ...prev, [row.id]: e.target.value }))} /></TableCell>
          <TableCell><Button disabled={busy || !canManage || !drafts[row.id]?.trim() || drafts[row.id] === row.name} onClick={() => save(row)} aria-label={`Salvar opção ${row.name}`}>Salvar</Button></TableCell></TableRow>)}
      </TableBody></Table></TableContainer>
      {canManage && <Stack component="form" onSubmit={e => { e.preventDefault(); save(); }} direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 2 }}>
        <TextField fullWidth required label="Nova opção" value={name} disabled={busy} onChange={e => setName(e.target.value)} />
        <Button type="submit" variant="contained" disabled={busy || !name.trim()}>Adicionar</Button>
      </Stack>}
    </DialogContent><DialogActions><Button disabled={busy} onClick={onClose}>Fechar</Button></DialogActions>
  </Dialog>;
}
